//This code was automatically generated by running scripts/generate-i18n-messages.ts
//PLEASE DO NOT EDIT MANUALLY
import * as en from "./en";

export async function getMessages(currentLanguageTag: string) {
    const { default: messages } = await (() => {
        switch (currentLanguageTag) {
            case "en": return en;
            case "ar": return import("./ar");
            case "ca": return import("./ca");
            case "cs": return import("./cs");
            case "da": return import("./da");
            case "de": return import("./de");
            case "el": return import("./el");
            case "es": return import("./es");
            case "fa": return import("./fa");
            case "fi": return import("./fi");
            case "fr": return import("./fr");
            case "hu": return import("./hu");
            case "it": return import("./it");
            case "ja": return import("./ja");
            case "lt": return import("./lt");
            case "lv": return import("./lv");
            case "nl": return import("./nl");
            case "no": return import("./no");
            case "pl": return import("./pl");
            case "pt-BR": return import("./pt-BR");
            case "ru": return import("./ru");
            case "sk": return import("./sk");
            case "sv": return import("./sv");
            case "th": return import("./th");
            case "tr": return import("./tr");
            case "zh-CN": return import("./zh-CN");
            default: return { "default": {} };
        }
    })();
    return messages;
}